import type { DeviceCommandRecord, IssueCommandInput } from '@grosync/common';
import { apiRequest } from './client';

export const fetchDeviceCommands = (deviceId: string): Promise<DeviceCommandRecord[]> =>
  apiRequest<DeviceCommandRecord[]>(`/api/devices/${deviceId}/commands`);

export const sendDeviceCommand = (
  deviceId: string,
  body: IssueCommandInput,
): Promise<DeviceCommandRecord> =>
  apiRequest<DeviceCommandRecord>(`/api/devices/${deviceId}/commands`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
